import {currentShippingAddressStyles} from "@insite/content-library/Widgets/Addresses/CurrentShippingAddress"
import { css } from "styled-components";

currentShippingAddressStyles. useBillingAddress= {
    button: {
        mergeCss: true,
        color: "secondary",
        css: css`
            margin-top: 20px;
        `,
    },
}